var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Well } from "@brushfire/ui";
import { useState, useEffect } from "react";
import { doc, onSnapshot, getFirestore } from "firebase/firestore";
import fb from "./firebase";
import EventHeader from "./components/Pages/Register/EventHeader";
import { Tab } from "./components/Pages/Register";
import Skeleton from "@material-ui/lab/Skeleton";
var MaintenanceView = function (_a) {
    var settings = _a.settings, eventNumber = _a.eventNumber, isWidget = _a.isWidget;
    var _b = __read(useState(), 2), event = _b[0], setEvent = _b[1];
    var firestore = getFirestore(fb);
    useEffect(function () {
        if (eventNumber) {
            return onSnapshot(doc(firestore, "events", eventNumber), function (doc) {
                setEvent(doc.data());
            });
        }
    }, [eventNumber]);
    return (_jsxs(_Fragment, { children: [event ? (_jsx("div", __assign({ className: "ta-left" }, { children: _jsx(EventHeader, { event: event, currentTab: Tab.DASHBOARD, isLoading: !event, isWidget: isWidget, userCanManage: false, path: "" }) }))) : (_jsx(_Fragment, { children: !!eventNumber && (_jsxs(Well, __assign({ className: "well-lg" }, { children: [_jsx(Skeleton, { variant: "rect", width: "70%", height: "36px", className: "m-bottom" }), _jsx(Skeleton, { variant: "rect", width: "35%" })] }))) })), _jsxs(Well, __assign({ className: "well-lg" }, { children: [_jsx("h1", __assign({ className: "maintenance-heading" }, { children: settings.maintenance.heading })), _jsx("p", { children: settings.maintenance.body })] }))] }));
};
export default MaintenanceView;
